export default {

  numWithCommas(number: string|number): string {
    number = String(number);
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },

  numRemoveCommas(number: string): string {
    return number.replace(/[^\d]+/g, "");
  },

  numRemoveLeftZero(number: string): string {
    return number.replace(/(^0+)/, "");
  },

  removeCharacterExceptKorEngNum(input: string): string {
    const exceptKoreanEnglishNumber = /[^a-zA-Zㄱ-힣0-9]/gi;
    return input.replace(exceptKoreanEnglishNumber, '');
  },

  removeCharacterExceptKorEng(input: string): string {
    const exceptKoreanEnglish = /[^a-zA-Zㄱ-힣]/gi;
    return input.replace(exceptKoreanEnglish, '');
  },

  removeCharacterExceptNumber(input: string): string {
    const exceptNumber = /[^0-9]/gi;
    return input.replace(exceptNumber, '');
  },

  getTextByte(str: string): number {
    //한글 2바이트까지 계산하기위함.
    let len = 0;
    for (let i = 0; i < str.length; i++) {
      // console.log(escape(str.charAt(i)));
      // 한글 1글자를 escape 해보면, 아래와 같은 6자리의 유니코드문자가 나온다는 것을 알 수 있습니다.
      // %uB098
      // 이 때, 유니코드는 2바이트이므로 2바이트로 계산
      if (escape(str.charAt(i)).length == 6) {
        len++;
      }
      len++;
    }
    return len;
  },

  groupBy<T, K extends keyof T>(array: T[], key: K) : Map<T[K], T[]> {
    const map = new Map<T[K], T[]>();
    array.forEach(item => {
      const itemKey = item[key];
      if (map.has(itemKey)) {
        map.get(itemKey)!.push(item);
      } else {
        map.set(itemKey, new Array<T>(item));
      }
    });
    return map;
  },

  isEmptyString(str: string | undefined | null): boolean {
    return str === null || str === undefined || str === '';
  },

  convertYnToBoolean(str: string | undefined): boolean {
    return str === 'Y';
  },

  /*
    개행문자를 포함한 문자열을 개행문자를 구분자로 삼아 문자열 배열로 반환하는 메소드
   */
  splitByNewline(str: string | undefined): Array<string> {
    const newLine = /(\r\n|\r|\n)/;
    return str?.split(newLine) ?? [];
  },

  /*
    문자열이 개행문자 포함여부를 반환하는 메소드
   */
  hasNewlineCharacter(str: string): boolean {
    const newLine = /(\r\n|\r|\n)/;
    return newLine.test(str);
  },

  isAndroid(): boolean {
    return this.getOS() === 'Android';
  },

  isIOS(): boolean {
    return this.getOS() === 'iOS';
  },

  getOS(): string {
    let os = "can't detect os";
    const userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'];

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }
    return os;
  }
};